import { useQuery } from "react-query";
import { getStudentDocuments } from "../services/school/student/getStudentDocuments";
import { PagedRequestType } from "../types/PagedResults";
import { Key_studentDocuments } from "../utils/constants";

export const useGetStudentDocumentsQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_studentDocuments, JSON.stringify(data)],
    () => getStudentDocuments(data),
    options?{...options}:{}

  );